var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "d3a084c571e23a1197b9a3547810644d.png",
    width: 60,
    height: 60
});